import React, { FC, ReactNode, useState } from 'react';
import { ENUM_PROCUREMENT_STATUS, KitchenProcurementType } from 'models/procurement.model';
import { KitchenProcurementContext } from './context';

export const DefaultProcurement: KitchenProcurementType = {
  cokitched_id: '',
  id: '',
  items: [],
  status: ENUM_PROCUREMENT_STATUS.PENDING,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  code: 0
};
const KitchenProcurementProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [procurementToUpdate, setProcurementToUpdate] =
    useState<KitchenProcurementType>(DefaultProcurement);
  return (
    <KitchenProcurementContext.Provider
      value={{
        procurementToUpdate,
        setProcurementToUpdate
      }}>
      {children}
    </KitchenProcurementContext.Provider>
  );
};

export default KitchenProcurementProvider;
